import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import styled from 'styled-components';

export const StyledActionsWrap = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.75rem;
`;

export const StyledActionButton = styled(Button)<{ $color: string }>`
  &&& {
    background: ${({ $color }) => $color};
    padding: 0.25rem;
    border: none;
    max-width: 7.125rem;
    min-width: 2.125rem;
    height: 2.125rem;
    color: ${COLORS.WHITE};
    ${pickThemeFontStyles('12', '14', 'BOLD')};

    :hover {
      background: ${({ $color }) => $color};
    }
  }

  svg {
    path {
      fill: ${COLORS.WHITE};
    }
  }
`;

export const StyledLink = styled.a<{ $color: string }>`
  &&& {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 7.125rem;
    min-width: 2.125rem;
    height: 2.125rem;
    border-radius: 0.25rem;
    cursor: pointer;
    text-decoration: none;
    background: ${({ $color }) => $color};
    transition: border-color 0.2s linear;

    :hover {
      background: ${({ $color }) => $color};
      border: 1px solid ${COLORS.BLACK_PRIMARY};
    }

    svg {
      path {
        fill: ${COLORS.WHITE};
      }
    }
  }
`;
